import { useEffect, useState } from 'react';

/** getPDP
 *
 * Fetch the current pdp and manage the loading and error state */
export const getPDP = (fetchProduct, deps = []) => {
  const [{ pdp, loading, error }, setPDP] = useState({
    pdp: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await fetchProduct();
        setPDP({ pdp: data, loading: false, error: null });
      } catch (fetchError) {
        const { response } = fetchError;
        let err = fetchError.message;
        if (response && response.data && response.data.message) {
          err = response.data.message;
        }
        setPDP({ pdp: null, loading: false, error: err });
      }
    };
    fetchData();
  }, deps);

  return [pdp, loading, error];
};

export default getPDP;
